import { render } from "./image-container-with-modal.vue?vue&type=template&id=79b3f174&scoped=true&ts=true"
import script from "./image-container-with-modal.vue?vue&type=script&lang=ts"
export * from "./image-container-with-modal.vue?vue&type=script&lang=ts"

import "./image-container-with-modal.vue?vue&type=style&index=0&id=79b3f174&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b3f174"]])

export default __exports__